export default __webpack_public_path__ + "static/media/Acacia Bark.d54a5570.PNG";